import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import {
  CompensationSource,
  type GetCompensationConfigResponseAPI,
} from '@omnipresentgroup/types';
import { HttpResponse, http } from 'msw';

import {
  API_BASE,
  CONFIGURATION_API_PATH,
  VARIANT_PAYMENTS_API_PATH,
} from './constants';
import {
  GET_COMPENSATION_VARIANT_PAYMENTS_RESPONSE,
  GET_CON_COMPENSATION_CONFIG_RESPONSE,
  GET_MOM_COMPENSATION_CONFIG_RESPONSE,
} from './fixtures';

export const compensationHandlers = [
  http.get(`*${API_BASE}/${CONFIGURATION_API_PATH}`, ({ request }) => {
    let response: GetCompensationConfigResponseAPI;
    const source = new URL(request.url).searchParams.get(
      'source',
    ) as CompensationSource;
    switch (source) {
      case CompensationSource.MONTH_ON_MONTH: {
        response = GET_MOM_COMPENSATION_CONFIG_RESPONSE;
        break;
      }
      case CompensationSource.CONTRACTUAL: {
        response = GET_CON_COMPENSATION_CONFIG_RESPONSE;
        break;
      }
    }
    return HttpResponse.json(response, {
      status: HTTPStatusCodes.OK,
    });
  }),
  http.get(`*${API_BASE}/${VARIANT_PAYMENTS_API_PATH}`, () =>
    HttpResponse.json(GET_COMPENSATION_VARIANT_PAYMENTS_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_BASE}/${VARIANT_PAYMENTS_API_PATH}/:id`, ({ params }) => {
    return HttpResponse.json(
      GET_COMPENSATION_VARIANT_PAYMENTS_RESPONSE.find(
        (item) => item.id === params.id,
      ),
      { status: HTTPStatusCodes.OK },
    );
  }),
  http.post(`${API_BASE}/${VARIANT_PAYMENTS_API_PATH}/init`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.NO_CONTENT,
      },
    ),
  ),
  http.post(`${API_BASE}/${VARIANT_PAYMENTS_API_PATH}`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.RESOURCE_CREATED,
      },
    ),
  ),
  http.patch(`${API_BASE}/${VARIANT_PAYMENTS_API_PATH}/:id`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
  http.delete(`${API_BASE}/${VARIANT_PAYMENTS_API_PATH}/:id`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.NO_CONTENT,
      },
    ),
  ),
];
